import React from 'react';
import { Link } from 'react-router-dom';

export function WorkflowSteps({ current = 1, steps, label = 'Project progress' }) {
  const items = steps || [
    { title: 'Set up project', detail: 'Scope, dates and budget' },
    { title: 'Choose contractor', detail: 'People, price and availability' },
    { title: 'Review and confirm', detail: 'Agree the hours and quote' },
  ];
  return <nav aria-label={label} className="mb-6"><ol className="grid gap-2 md:grid-cols-3">
    {items.map((step, i) => <li key={step.title} aria-current={current === i + 1 ? 'step' : undefined} className={`rounded-2xl border p-4 flex items-start gap-3 ${current === i + 1 ? 'border-teal-600 bg-teal-50' : 'border-[var(--avcp-line)] bg-white'}`}>
      <span aria-hidden="true" className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center font-semibold ${current >= i + 1 ? 'bg-[var(--avcp-primary)] text-white' : 'bg-slate-100 text-slate-600'}`}>{current > i + 1 ? '✓' : i + 1}</span>
      <div>{step.to ? <Link className="font-semibold hover:underline" to={step.to}>{step.title}</Link> : <span className="font-semibold">{step.title}</span>}<p className="text-xs mt-1 text-[var(--avcp-ink-soft)]">{step.detail}</p></div>
    </li>)}
  </ol></nav>;
}
export const changeSteps = [
  { title: 'Edit the project', detail: 'Update the details and explain why' },
  { title: 'Republish', detail: 'Notify the team and ask the contractor to review' },
  { title: 'Approve the changes', detail: 'The client approves the confirmed quote' },
];
